import type { Whirlpool } from '@renec-foundation/nemoswap-sdk'
import { PriceMath } from '@renec-foundation/nemoswap-sdk'
import Decimal from 'decimal.js'

type GetTokenRateParams = {
  pool: Whirlpool
  tokenAddress: string
  tokenUSDRate: number
}

export const getTokensRate = (params: GetTokenRateParams) => {
  const { pool, tokenAddress, tokenUSDRate } = params
  const tokenAInfo = pool.getTokenAInfo()
  const tokenBInfo = pool.getTokenBInfo()

  const tokenMintAddressA = tokenAInfo.mint.toBase58()
  const tokenMintAddressB = tokenBInfo.mint.toBase58()

  if (![tokenMintAddressA, tokenMintAddressB].includes(tokenAddress)) {
    return null
  }

  const { sqrtPrice } = pool.getData()
  const bPerAPrice = PriceMath.sqrtPriceX64ToPrice(
    sqrtPrice,
    tokenAInfo.decimals,
    tokenBInfo.decimals,
  )
  const aPerBPrice = PriceMath.invertPrice(bPerAPrice, tokenAInfo.decimals, tokenBInfo.decimals)

  let usdRateA = new Decimal(1)
  let usdRateB = new Decimal(1)
  if (tokenMintAddressA === tokenAddress) {
    usdRateA = usdRateA.times(tokenUSDRate)
    usdRateB = usdRateB.times(new Decimal(tokenUSDRate).times(aPerBPrice))
  } else {
    usdRateA = usdRateA.times(new Decimal(tokenUSDRate).times(bPerAPrice))
    usdRateB = usdRateB.times(tokenUSDRate)
  }

  return [usdRateA, usdRateB]
}
